import { withAuthProvider } from "../../../../lib/auth";
import JobApplicationView from "./view";
import withFormState from "./state";
import withFormValidation from "./validation";
import { withRouter } from "react-router";
import withFormHandlers from "./handlers";

const JobApplicationForm = withFormState(
  withFormValidation(
    withRouter(withFormHandlers(withAuthProvider(JobApplicationView))),
  ),
);

JobApplicationForm.displayName = "JobApplicationForm";

export default JobApplicationForm;
